import React from 'react';
import classnames from 'classnames';
import { parseUrl } from 'query-string';
import { parse } from 'node-html-parser';
import YouTube from 'react-youtube';

const youtubeStyles = 'wp-block-embed is-type-video is-provider-youtube wp-block-embed-youtube';

export function WPYoutube({ data }) {
  const { className, url } = data.attributes;

  const classNames = classnames(youtubeStyles, className);

  const videoId = parseUrl(url).query.v;

  const parsed = parse(data.rendered.trim());
  const figcaption = parsed.lastChild?.childNodes?.find(p => p.rawTagName == 'figcaption');

  const opts = {
    height: 'auto',
    width: '100%',
  };

  return (
    <div className={classNames}>
      <YouTube
        className="YouTubeIFrame"
        containerClassName="YouTubeIFrameWrapper"
        videoId={videoId}
        opts={opts}
      />
      {figcaption && <figcaption dangerouslySetInnerHTML={{ __html: figcaption.innerHTML }} />}
    </div>
  );
}
